module.exports = __webpack_public_path__ + "img/KN-SK.f53c1e6b.svg";